import { Button, Card } from "@rumbledirect/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DatePicker, message, Modal, Typography } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import { useState } from "react";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { useViewConfigurationClient } from "../client";

export interface AppointmentTimeSlotCardProps {
  title: string;
  submitEndpoint: string;
  submitField: string;
  plannedStart: string;
}

export const AppointmentTimeSlotCard = ({
  title,
  submitEndpoint,
  submitField,
  plannedStart,
}: AppointmentTimeSlotCardProps) => {
  const axiosInstance = useViewConfigurationClient();
  const queryClient = useQueryClient();
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [date, setDate] = useState<Dayjs | null>(null);

  const openModal = () => {
    setDate(plannedStart ? dayjs(plannedStart) : null);
    setOptionsVisible(true);
  };

  const submitMutation = useMutation({
    mutationFn: async () =>
      axiosInstance.patch(
        submitEndpoint,
        { [submitField]: date?.toISOString() ?? null },
        { headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON } },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["view-configuration"] });
      setOptionsVisible(false);
    },
    onError: () => {
      message.error("Er is een fout opgetreden. Probeer het opnieuw.");
    },
  });

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{title}</span>
          <Button
            type="link"
            style={{ padding: 0, fontWeight: "normal" }}
            onClick={openModal}
          >
            wijzigen
          </Button>
        </div>
      }
    >
      <Typography.Paragraph type="secondary" style={{ margin: 0 }}>
        {plannedStart
          ? dayjs(plannedStart).format("DD-MM-YYYY")
          : "Nog geen datum gepland."}
      </Typography.Paragraph>

      <Modal
        title={`${title} wijzigen`}
        open={optionsVisible}
        onCancel={() => setOptionsVisible(false)}
        onOk={() => submitMutation.mutate()}
        okText="Opslaan"
        okButtonProps={{ loading: submitMutation.isPending }}
      >
        <DatePicker
          style={{ width: "100%" }}
          format="DD-MM-YYYY"
          placeholder="Kies een datum"
          value={date}
          onChange={setDate}
        />
      </Modal>
    </Card>
  );
};
